import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'epDropdownItem',
    standalone: false
})
export class EpDropdownPipeItem implements PipeTransform {

  transform(item: string, value: string): any {
    if (!item) {
      return '';
    }
    if (value) {
      let middle = value;
      let begin = '';
      let end = '';
      let middleIndex: number;
      // find middle index
      const firstResultIndex = item.toLowerCase().indexOf(middle.toLowerCase());
      if(firstResultIndex === 0) {
        middleIndex = firstResultIndex;
      } else if(item[firstResultIndex - 1]) {
        const spaceBeforeMiddle = ' ' + middle;
        middleIndex = item.toLowerCase().indexOf(spaceBeforeMiddle.toLowerCase()) + 1;
      }
      if (middleIndex !== undefined) {
        const endIndex = middleIndex + middle.length;
        let middleToEndCharCount = middle.length;

        // if there are charcters left after the middle
        if(item.charAt(endIndex)) {
          end = item.slice(endIndex);
          middleToEndCharCount = middleToEndCharCount + end.length;
        }
        // if there are characters before the middle
        if(middleToEndCharCount !== item.length) {
          begin = item.slice(0, middleIndex);
        }

        // this ensures proper capitalization in the dropdown despite user input
        middle = item.slice(middleIndex, endIndex);

        return `${begin}<b>${middle}</b>${end}`;
      } else {
        // if middle index not found provide default
        return `<span class='userInputValueListItem'>${item}</span>`;
      }
    } else {
      return `<span class='userInputValueListItem'>${item}</span>`;
    }
  }
}
